import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getPortalLocData from '../config/loc';
import Hero from '../components/Hero';

import NotFoundPage from '../components/NotFoundPage';







export class GenericContent extends React.Component{
    constructor(props){
        super(props);
    }
    componentDidMount() {
        if (this.copy().metaTitle) {
            document.title = this.copy().metaTitle;
        } else if (this.copy().title) {
            document.title = this.copy().title;
        }
    }

    // TODO, move to willMount()
    copy() {
        let searchVal = this.props.history.location.pathname.slice(1).replace(/-([a-z])/g, (g) => {
            return g[1].toUpperCase();
        }).replace('/', '');
        
        let page = getPortalLocData().pages[searchVal];

        if (this.props.history.location.pathname === '/') {
            return getPortalLocData().pages.home
        } else {
            return page;
        }
    }

    render(){
        return(
            <div>
                { this.copy() &&
                    <div>
                        { this.copy().title && 
                            <Hero  
                            title={this.copy().title}
                            img={"/images/" + getPortalLocData().name + "/bg.jpg"}/>
                        }

                        <div className="limit-content main-container">
                            <div className="row">
                                <div className="col-md-12" dangerouslySetInnerHTML={{ __html: this.copy().contents }} >
                                </div>
                            </div>
                        </div>
                    </div>
                }

                { !this.copy() &&
                    <NotFoundPage/>
                }
            </div>

        );
    }

}
GenericContent.propTypes={
    locationDetail:PropTypes.object,
    accountDetails:PropTypes.object
}


function mapStateToProps(state) {
    return {
        locationDetail: state.locationDetail,
        accountDetails:state.accountDetails
    };
  }
  

  
  export default connect(
    mapStateToProps,
    null
  )(GenericContent);





// WEBPACK FOOTER //
// ./src/containers/GenericContent.jsx